import { render, staticRenderFns } from "./SmplEditCompChild.vue?vue&type=template&id=fc6f54ec&scoped=true&"
import script from "./SmplEditCompChild.vue?vue&type=script&lang=js&"
export * from "./SmplEditCompChild.vue?vue&type=script&lang=js&"
import style0 from "./SmplEditCompChild.vue?vue&type=style&index=0&id=fc6f54ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6f54ec",
  null
  
)

export default component.exports